// conf ws消息数据

const CONF_STATUS_START = 1; // 会议开始
const CONF_STATUS_END = -1; // 会议结束
const CONF_STATUS_UN_START = -2; // 会议未开始
const CONF_STATUS_START_RECORD = 100; // 会议录音开启中
const CONF_STATUS_ON_RECORD = 101; // 会议录音状态
const CONF_STATUS_OFF_RECORD = 102; // 会议非录音状态
const CONF_STATUS_PAUSE_RECORD = 103; // 暂停录音状态
const CONF_STATUS_UN_QA = 20; // 未开启录音状态
const CONF_STATUS_QA = 21; // 开启问答状态
const CONF_STATUS_UN_LOCK = 30; // 未开启锁定状态
const CONF_STATUS_LOCK = 31; // 开启锁定状态
const CONF_STATUS_UN_MUTE = 40; // 未开启全体静音状态
const CONF_STATUS_MUTE = 41; // 开启全体静音状态
const CONF_STATUS_CHAIRMAN_UNMUTE = 50;
const CONF_STATUS_CUST_UNMUTE = 51;
const CONF_STATUS_STOP_WAITLINE = 60;
const CONF_STATUS_CONNECTION_WAITLINE = 61; // 正在连接等待音
const CONF_STATUS_START_WAITLINE = 62;

export function getConfConnectionWaitLine() {
  return CONF_STATUS_CONNECTION_WAITLINE;
}

export function getConfStartWaitLine() {
  return CONF_STATUS_START_WAITLINE;
}

export function getConfStopWaitLine() {
  return CONF_STATUS_STOP_WAITLINE;
}

export function getConfCustUnmute() {
  return CONF_STATUS_CUST_UNMUTE;
}

export function getConfChairmanUnmute() {
  return CONF_STATUS_CHAIRMAN_UNMUTE;
}

export function isConfStart(status) {
  return CONF_STATUS_START === status;
}

export function getConfStart() {
  return CONF_STATUS_START;
}

export function isConfUnStart(status) {
  return CONF_STATUS_UN_START === status;
}

export function getConfUnStart() {
  return CONF_STATUS_UN_START;
}

export function isConfEnd(status) {
  return CONF_STATUS_END === status;
}

export function getConfEnd() {
  return CONF_STATUS_END;
}

export function isOnRecord(status) {
  return CONF_STATUS_ON_RECORD === status;
}

export function isRecordStart(status) {
  return CONF_STATUS_START_RECORD === status;
}

export function getRecordStart() {
  return CONF_STATUS_START_RECORD;
}

export function getOnRecord() {
  return CONF_STATUS_ON_RECORD;
}

export function isOffRecord(status) {
  return CONF_STATUS_OFF_RECORD === status;
}

export function getOffRecord() {
  return CONF_STATUS_OFF_RECORD;
}

export function isPauseRecord(status) {
  return CONF_STATUS_PAUSE_RECORD === status;
}

export function getPauseRecord() {
  return CONF_STATUS_PAUSE_RECORD;
}

export function isStopQa(status) {
  return CONF_STATUS_UN_QA === status;
}

export function getStopQa() {
  return CONF_STATUS_UN_QA;
}

export function isStartQa(status) {
  return CONF_STATUS_QA === status;
}

export function getStartQa() {
  return CONF_STATUS_QA;
}

export function isUnLock(status) {
  return CONF_STATUS_UN_LOCK === status;
}

export function getUnLock() {
  return CONF_STATUS_UN_LOCK;
}

export function isLock(status) {
  return CONF_STATUS_LOCK === status;
}

export function getLock() {
  return CONF_STATUS_LOCK;
}

export function isUnMute(status) {
  return CONF_STATUS_UN_MUTE === status;
}

export function getUnMute() {
  return CONF_STATUS_UN_MUTE;
}

export function isMute(status) {
  return CONF_STATUS_MUTE === status;
}

export function getMute() {
  return CONF_STATUS_MUTE;
}
